import { useMount } from 'react-use';

import { registerSalesModeActivator } from '@dreryk/demo-variant-frontend';

export const SalesMode = (): null => {
   useMount(registerSalesModeActivator);

   return null;
};
